<template>
    <div id="layout__basic">
        <slot />

        <snackbar-message />
    </div>
</template>

<script>
import SnackbarMessage from "@/components/SnackbarMessages";

export default {
  components: {
    SnackbarMessage
  }
};
</script>

<style lang="scss">
    #layout__basic {
        display: flex;
        height: 100vh;
        flex: 1 0 auto;
    }
</style>
